export default "__VITE_ASSET__Cxmeid3p__"